/**
 * Design Library — pattern definition helper.
 *
 * Applies the structural defaults every pattern shares (version, no variant
 * parent, empty relationship lists) and deep-freezes the result, so each
 * pattern file declares only its design knowledge. Pure; no logic beyond
 * defaults and immutability.
 */

import { DEFAULT_PATTERN_VERSION } from '../librarySchema';

const deepFreeze = (obj) => {
  Object.values(obj).forEach((v) => {
    if (v && typeof v === 'object' && !Object.isFrozen(v)) deepFreeze(v);
  });
  return Object.freeze(obj);
};

/** Define one library pattern with defaults applied. */
export const definePattern = (pattern) => deepFreeze({
  version: DEFAULT_PATTERN_VERSION,
  variantOf: null,
  compatiblePatterns: [],
  incompatiblePatterns: [],
  dependencies: [],
  ...pattern,
});
